import { RootState } from '../../store'

export const contractsSelector = (state: RootState) => {
  const { contracts } = state

  return contracts
}
